export const SDK_VERSION = '7.21.1';
